import { render, staticRenderFns } from "./AdminImage.vue?vue&type=template&id=3cc55417&scoped=true&"
import script from "./AdminImage.vue?vue&type=script&lang=ts&"
export * from "./AdminImage.vue?vue&type=script&lang=ts&"
import style0 from "./AdminImage.vue?vue&type=style&index=0&id=3cc55417&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc55417",
  null
  
)

export default component.exports